define.alias("ember-useragent/helpers/user-agent", "settings/helpers/user-agent");